module.exports = __webpack_public_path__ + "static/media/newsletter-banner.497d69cf.png";